var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{attrs:{"icon":['fas', 'spinner'],"size":_vm.size,"spin":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }